module.exports = __webpack_public_path__ + "img/5_118.b9bed190.png";